module.exports = __webpack_public_path__ + "img/photo_mountains.e59edb80.jpg";